export class GoogleMapConfig {
  /**
   * Default Google map style which will be used in all the maps.
   * Currently this values is from the Silver theme from Google Map theme generator.
   */
  static readonly defaultMapStyle = [
    {
      elementType: 'labels.text.fill',
      stylers: [
        { color: '#000000' }, // Change label color if needed
        { fontFamily: 'Poppins' } // Custom font
      ]
    },
    {
      elementType: 'labels.text.stroke',
      stylers: [
        { color: '#ffffff' } // Stroke color to make text more readable
      ]
    },
    {
      featureType: 'poi.business',
      stylers: [{ visibility: 'off' }] // Hides businesses like cafes and restaurants
    },
    {
      featureType: 'poi.attraction',
      stylers: [{ visibility: 'off' }] // Hides tourist attractions
    },
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }] // Hides labels for points of interest
    }
  ];

  /**
   *
   */
  static readonly infoWindowTemplate = `\
    <div class="info-window-container">\
      <div class="info-window-header">\
        <span class="index">##index##</span>\
        <div class="address">\
          <h3>##streetAddress##</h3>\
          <span>##remainingAddress##</span>\
        </div>\
        <!-- <span class="close" (click)="closeInfoWindow()">\
          <img src="../../assets/close.svg" width="20" height="20" />\
        </span> -->\
      </div>\

      <div class="info-window-body">\
        <div class="info-window-property-image">\
          <img src="##propertyImage##" />\
          <span class="info-window-property-status active">##mlsStatus##</span>\
          <span class="info-window-property-distance">##distance##</span>\
        </div>\
        <div class="info-window-property-info">\
          <div class="property-info-row"><b>##price##</b></div>\
          <div class="property-info-row"><b>##bedCount##</b> bd | <b>##bathCount##</b> bt</div>\
          <div class="property-info-row"><b>##livingArea##</b> sqft GLA</div>\
          <div class="property-info-row"><b>##lotSize##</b> sqft Lt.Size</div>\
          <div class="property-info-row"><b>##onMarketDays##</b> days</div>\
        </div>\
      </div>\

      <div class="info-window-footer">\
        <button id="selectButton" class="info-window-btn info-window-btn-select" style="display:'none'">\
          <span class="material-symbols-outlined">done</span> Select\
        </button>\
        <button  id="deselectButton" class="info-window-btn info-window-btn-deselect" style="display:'none'">\
          <span class="material-symbols-outlined">close</span> Deselect\
        </button>\
        <button  id="detailButton" class="info-window-btn info-window-btn-detail">\
          <span class="material-symbols-outlined">info</span> View Details\
        </button>\
      </div>\
    </div>\
  `;

  static readonly detailedInfoBox = `\
  <div class="map-info-box mapcard_base" id="pmx#PMXPropertyId#" data-pmx="#PMXPropertyId#"\
    style="background: #787878 url('#imageUrl#') no-repeat right top; background-size: cover;"> \
    <span id="detail#PMXPropertyId#"> \
      <div class="prop_info"> \
        <h3 id="price#PMXPropertyId#">$ #price#</h3> \
        <ul> \
          <li><p id="bed#PMXPropertyId#">#bedroomCount#</p> <span>Bed</span></li> \
          <li><p id="bath#PMXPropertyId#">#bathroomCount#</p> <span>Bath</span></li> \
          <li><p id="living#PMXPropertyId#">#livingArea#</p> <span>Sqft</span></li> \
          <li><p id="lot#PMXPropertyId#">#lotSizeSquareFeet#</p> <span>Sqft.lot</span></li> \
        </ul> \
        <span><p class="propertyData" id="address#PMXPropertyId#">#fullAddress#</p></span> \
      </div> \
    </span> \
  </div> `;

  static readonly multiplePropertyBox = `\
  <div class="map-info-box multiprop-card" id="pmx#PMXPropertyId#" data-pmx="#PMXPropertyId#"> \
    <span id="detail#PMXPropertyId#"> \
      <div class="multiprop_info"> \
        <h3 id="price#PMXPropertyId#">$ #price#</h3> \
        <span class="#statusClass#">#listingStatus#</span> \
        <ul> \
          <li><p id="bed#PMXPropertyId#">#bedroomCount#</p> <span>Bed</span></li> \
          <li><p id="bath#PMXPropertyId#">#bathroomCount#</p> <span>Bath</span></li> \
          <li><p id="living#PMXPropertyId#">#livingArea#</p> <span>Sqft</span></li> \
          <li><p id="lot#PMXPropertyId#">#lotSizeSquareFeet#</p> <span>Sqft.lot</span></li> \
        </ul> \
        <span><p class="propertyData" id="address#PMXPropertyId#">#fullAddress#</p></span> \
      </div> \
    </span> \
  </div> `;
}
